import {
  Col, Flex, Row
} from "antd";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../components/layout";
import { data } from "../data/psychologists";
import Container from "../components/container";

const ExpertDetails = () => {
  const { entity } = useParams();
  const details = data.get(entity || "");

  if (!details) return null;

  return (
    <Layout>
      <Container className="pb-[1.5rem]">
        <Flex align="center" wrap="wrap" gap=".5rem" className="py-[1.5rem] text-base text-[#10182880]">
          <NavLink to="/" className="text-[#10182880] hover_text-[#101828b3]">
            In buona salute
          </NavLink>
          <span>/</span>
          <NavLink to="/psiconcologi" className="text-[#10182880] hover_text-[#101828b3]">
            I nostri psiconcologi
          </NavLink>
          <span>/</span>
          <span className="text-[#101828]">{details?.name}</span>
        </Flex>
        <Row gutter={24}>
          <Col span={24} lg={6}>
            <img src={`/landing/experts/${entity}.webp`} alt="entity" className="w-full"/>
            <span className="block py-[4px] my-[8px] pl-[8px] border-solid border-0 border-l-[#204380] border-l-[4px]">
              {details.availability}
            </span>
          </Col>
          <Col span={24} lg={18}>
            <h2 className="font-bold text-[2rem] mb-[8px]">{details.name}</h2>
            <Flex gap={12} align="center" className="mb-[3rem]">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path d="M13.9997 25.6668C20.443 25.6668 25.6663 20.4435 25.6663 14.0002C25.6663 7.55684 20.443 2.3335 13.9997 2.3335C7.55635 2.3335 2.33301 7.55684 2.33301 14.0002C2.33301 20.4435 7.55635 25.6668 13.9997 25.6668Z" stroke="#204480" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16.1386 8.51683C16.1386 8.19013 16.1386 8.02678 16.075 7.902C16.0191 7.79224 15.9298 7.703 15.8201 7.64708C15.6953 7.5835 15.5319 7.5835 15.2052 7.5835H12.7941C12.4674 7.5835 12.3041 7.5835 12.1793 7.64708C12.0695 7.703 11.9803 7.79224 11.9244 7.902C11.8608 8.02678 11.8608 8.19013 11.8608 8.51683V10.9279C11.8608 11.2546 11.8608 11.418 11.7972 11.5428C11.7413 11.6525 11.652 11.7418 11.5423 11.7977C11.4175 11.8613 11.2541 11.8613 10.9275 11.8613H8.51634C8.18964 11.8613 8.02629 11.8613 7.90151 11.9249C7.79175 11.9808 7.70251 12.07 7.64659 12.1798C7.58301 12.3046 7.58301 12.4679 7.58301 12.7946V15.2057C7.58301 15.5324 7.58301 15.6958 7.64659 15.8205C7.70251 15.9303 7.79175 16.0195 7.90151 16.0755C8.02629 16.1391 8.18964 16.1391 8.51634 16.1391H10.9275C11.2541 16.1391 11.4175 16.1391 11.5423 16.2026C11.652 16.2586 11.7413 16.3478 11.7972 16.4576C11.8608 16.5823 11.8608 16.7457 11.8608 17.0724V19.4835C11.8608 19.8102 11.8608 19.9735 11.9244 20.0983C11.9803 20.2081 12.0695 20.2973 12.1793 20.3532C12.3041 20.4168 12.4674 20.4168 12.7941 20.4168H15.2052C15.5319 20.4168 15.6953 20.4168 15.8201 20.3532C15.9298 20.2973 16.0191 20.2081 16.075 20.0983C16.1386 19.9735 16.1386 19.8102 16.1386 19.4835V17.0724C16.1386 16.7457 16.1386 16.5823 16.2021 16.4576C16.2581 16.3478 16.3473 16.2586 16.4571 16.2026C16.5819 16.1391 16.7452 16.1391 17.0719 16.1391H19.483C19.8097 16.1391 19.9731 16.1391 20.0978 16.0755C20.2076 16.0195 20.2968 15.9303 20.3528 15.8205C20.4163 15.6958 20.4163 15.5324 20.4163 15.2057V12.7946C20.4163 12.4679 20.4163 12.3046 20.3528 12.1798C20.2968 12.07 20.2076 11.9808 20.0978 11.9249C19.9731 11.8613 19.8097 11.8613 19.483 11.8613H17.0719C16.7452 11.8613 16.5819 11.8613 16.4571 11.7977C16.3473 11.7418 16.2581 11.6525 16.2021 11.5428C16.1386 11.418 16.1386 11.2546 16.1386 10.9279V8.51683Z" stroke="#204480" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-base text-[#475467]">{details.role}</span>
            </Flex>
            <div className="text-base border-0 border-b border-solid border-b-[#475467] pb-[1.5rem]">
              {details.description.map((desc) => (
                <p key={desc}>
                  {desc}
                </p>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default ExpertDetails;
